/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Vlaidslav Oshkanov
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import { Draggable } from 'react-beautiful-dnd';

import {
    DragItemContainerStyled,
    HandleContainerStyled,
    IconStyled,
    ItemBodyStyled,
} from './styled/DraggableItemStyled';

export interface IDraggableItemProps {
    icon: string;
    index: number;
    item: JSX.Element;
}

const DraggableItem = ({ icon, item, index }: IDraggableItemProps) => (
    <Draggable
        draggableId={index.toString()}
        index={index}
        key={index}
    >
        {
            (provided) => (
                <DragItemContainerStyled
                    {...provided.draggableProps}
                    ref={provided.innerRef}
                >
                    <ItemBodyStyled>
                        {item}
                        <HandleContainerStyled {...provided.dragHandleProps}>
                            <IconStyled src={icon}/>
                        </HandleContainerStyled>
                    </ItemBodyStyled>
                </DragItemContainerStyled>
            )
        }
    </Draggable>
);

export default DraggableItem;
